import React, {useState} from 'react';
import { Box, Typography, List, ListItem, Checkbox, Grid2, Button, TextField, Avatar, ListItemAvatar } from '@mui/material';
import { cart__items } from '../../data/StaticDatas';
import DeleteIcon from '../../assets/Delete.svg';
import CartQuantity from '../CartQuantity/CartQuantity';
import { useMediaQuery, useTheme } from '@mui/material';

const CartList = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm')); 
    const [checkedItems, setCheckedItems] = useState([]);
    const [cart, setCart] = useState(cart__items)
    console.log(cart)
  const handleToggle = (itemId) => {
    setCheckedItems((prev) =>
      prev.includes(itemId) ? prev.filter((id) => id !== itemId) : [...prev, itemId]
    );
  };
  

  const handleRemove = (itemId) => {
    // Implement removal logic, e.g., filtering out the item
    const filteredCart = cart.filter((item)=>item.id !== itemId);
    alert(`Remove item with id: ${itemId}`);
    setCart(filteredCart)
  };
    
  return (
<List style={{overflowY:'auto', mt:6}}>
      {cart.map((item) => (
          <Grid2 container alignItems="center" spacing={{xs:0, md:2}} sx={{justifyContent:'space-between', my:8}}>
            {/* Checkbox */}
            {isDesktop ? (
            <Grid2 item size={1} sx={{display:'flex', justifyContent:'center'}}>
              <Checkbox
                edge="start"
                sx={{
                    color: "rgba(182, 183, 185, 1)",
                    width:'100%', // Set the color
                    "&.Mui-checked": {
                      color: "rgba(29, 158, 52, 1)", // Change color when checked
                    },
                    transform: "scale(1.2)", // Adjust size
                  }}
                checked={checkedItems.includes(item.id)}
                onChange={() => handleToggle(item.id)}
              />
            </Grid2>
            ):(<></>)
            }

            {/* Item Image */}
            <Grid2 item size={2}>
              <img src={item.images[1]} alt={item.name} style={{width:'100%', height:'60px'}}/>
            </Grid2>

            {/* Item Details */}
            <Grid2 item size={4}>
              {isDesktop ? (
                <>
                <Typography variant="body1" color='rgba(18, 18, 18, 1)'>{item.name}</Typography>
              <Typography variant="body2" color='rgba(129, 139, 156, 1)' sx={{fontSize:'.8rem'}}>{item.sub_description}</Typography>
              </>
              ):
              (
                <>
                <Typography variant="body1" color='rgba(18, 18, 18, 1)'>{item.name.slice(0, 10)}...</Typography>
                <Typography variant="body2" color='rgba(129, 139, 156, 1)' sx={{fontSize:'.8rem'}}>{item.sub_description.slice(0, 10)}...</Typography>
                </>
              )}
              <Typography variant="body2" color="rgba(86, 4, 246, 1)" sx={{fontWeight:'700', fontSize:'1.25rem', my:1}}>
                {item.price}
              </Typography>
            </Grid2>

             <Grid2 size={4} sx={{display:{xs:'block', md:'flex'}}}>
            {/* Quantity Selector */}
            <Grid2 item size={6}>
              <CartQuantity item={item}/>
            </Grid2>

            {/* Remove Button */}
            <Grid2 item size={6}>
              <Button
                color="error"
                size="small"
                onClick={() => handleRemove(item.id)}
              >
                <img src={DeleteIcon} alt="delete" />
              </Button>
            </Grid2>
            </Grid2>
          </Grid2>
      ))}
    </List>

  )
}

export default CartList